export enum AuthStatus {
  AUTHENTICATED = 0,
  WAITING_OTP_VALIDATION = 1,
  WAITING_OTP_CHECK=2,
  WAITING_PIN_VALIDATION = 3,
  WAITING_CARD_VALIDATION = 4,
  WAITING_REGISTRATION = 5,
  WAITING_CREATE_PIN = 6,
  WAITING_REFRESH_PIN = 7
}
